export const ASSISTANT_AI_ESTIE_CHAT = 'ASSISTANT_AI_ESTIE_CHAT';
